import React from "react"
import clsx from "clsx"
import ProductFolioItemPresenterGeneral from "../../ProductFolioItemPresenter/tabs/ProductFolioItemPresenterGeneral"

class ServiceLogBuilderFolioItems extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'service-log-folio-items',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="service-log-folio-items">
        <ProductFolioItemPresenterGeneral
          product={this.props.folio_item.product}
          children={this.props.folio_item.children}
          amount={this.props.folio_item.total_amount}
          item_type={this.props.folio_item.folio_item_type}
          quantity={this.props.folio_item.quantity}
          item_date={this.props.folio_item.item_date}
          taxes={this.props.folio_item.product_taxes}

          folio={this.props.folio_item.folio}
          total_with_taxes={this.props.folio_item.total_amount_with_children}

          children_data_table_path={this.props.children_data_table_path}
          formatCurrency={this.props.formatCurrency}
          date_format={this.props.date_format}
          time_format={this.props.time_format}
          read_only={this.props.read_only}

         />
      </div>
    )
  }

}

export default ServiceLogBuilderFolioItems